export const complianceObject = {
    fileSize : 1048576
    // 1MB = 1024 * 1024 = 1048576
  }
  export const dateObject = {
   maxDate:'9999-05-31'
  }
  export const minDate = '1950-01-01'
  export const commonObject = {
    businessType: 2
  }
